<!-- ------------------------Компонент видалення акаунту ----------------------------------- -->
<template>
  <smallModal @escape="$emit('close')">
    <div class="del-acc-div">
      <h5>{{ lang['DeleteAccount'] }}: {{ personData.user_name }}?</h5>
      <hr>
      <div v-if="personData.have_password">
        <div v-if="ccc != null">
          <div class="buttons-flex-end">
            <button @click="captchaImg" class="btn" >
              <b-icon-arrow-repeat id="captcha-del"></b-icon-arrow-repeat>
            </button>
          </div>
          <div class="imgDiv">
            <img :src="ccc" class="capImg">
          </div>
          <label :for="captchaName">{{ lang['EnterCaptcha'] }}</label>
          <b-form-input v-model="captcha" :state="capState" :name="captchaName" autofocus />
        </div>
        <label for="accountPassword">{{ lang['Password'] }}</label>
        <b-form-input v-model="accountPassword" type="password" :state="passState" name="accountPassword"  />
      </div>

      <div v-else class="center-text">
        <span class="grey-span">{{ lang['FirstCreateAnAccountPassword'] }}</span>
        <hr>
      </div>
      <div class="buttons">
        <button class="btn btn-secondary" @click="$emit('close')">{{ lang['Сancel'] }}</button>
        <button v-if="personData.have_password" class="btn btn-success longWord" @click="save">{{ lang['Confirm'] }}</button>
        <button v-else class="btn btn-success" @click="goAddPass">{{ lang['Proceed'] }}</button>
      </div>
      <!-- этот див для автофокуса, чтобы работал Enter -->
      <div ref="delAcc"
          tabindex="0">
      </div>
    </div>
  </smallModal>
</template>

<script>
import { store } from '@/store.js'; // Глобальне сховище даних
import smallModal from '../modals/smallModal'; // Компонент маленького модального вікна
import { keyevent } from '@/main.js'; // Імпорт глобального об'єкта keyevent для обміну подіями між компонентами
import { rotate } from '../js/rotateBtn'; // Імпортуємо функцію rotate для обертання елемента на 180 градусів з анімацією
import { guid } from '../js/guid'; // Імпортуємо функцію guid для створення унікальних ідентифікаторів
import { errList } from '../js/CaptchaAndPassError';
import { regAPi } from '@/API.js';
import Cookies from 'js-cookie'; // Модуль для роботи з кукі

// Cтворюємо апі куків з налаштуванням дефолтного домену для продакшену
let apiCookies = Cookies;

if (process.env.NODE_ENV == 'production') {
   apiCookies = Cookies.withAttributes({domain: ".skyservice.online"})
}

const apiList = new regAPi();
export default {
  props: ['personData'],
  components: {
    smallModal
  },
  data() {
    return {
      accountPassword: '',
      ccc: null,
      captcha: '',
      guid_now: '',
      captchaName:'captcha_'+this.getRandNum(999,99999)
    }
  },
  created() {
    this.captchaImg();
  },
  mounted(){
    // автофокус для дива
    this.$nextTick(() => {
      this.$refs.delAcc.focus();
    });
    keyevent.$off('enter');
    keyevent.$on('enter', () => {
      this.personData.have_password ? this.save() : this.goAddPass()
    });
  },
  methods: {
    // ( костыль для модалки добавления пароля, обычный кейивэнт там не работает ) (можно удалить после теста)
    // onKeyDown(event) {
    //     if (event.key === "Enter") {
    //         this.personData.have_password ? this.save() : this.goAddPass()
    //     }
    // },
    getRandNum(min, max) {
      return Math.random() * (max - min) + min;
    },
    goAddPass() {
      this.$emit('close');
      this.$emit('goaddpass')
    },
    captchaImg() {
      try {
        // создаем гуид(файл guid.js) который скидываем для капичи состарта, потом, если юзер нажал сохранить, то скидываем текущий гуид на сервак для сравнения
        const a = guid();
        const c = apiList.captchaUID(a);
        this.ccc = c;
        this.guid_now = a;
        // крутилка для кнопки
        rotate('#captcha-del');
        this.captcha = ''
      } catch(err) {
        console.log(err)
      }
    },
    save() {
      try {
        if (this.passState && this.capState) {
          // для удаления аккаунта пользователю необходимо ввести пароль, так же, передаем текущий токен юзера
          apiList.delAccount({ token: store.token, password: this.accountPassword, captcha: this.captcha, captcha_guid: this.guid_now }).then(resp => {
            if (resp.data.status == 'done') {
              //удаляем токен
              apiCookies.set("token", '', {expires: -1});
              localStorage.removeItem('registration_phone');
              store.token = '';
              // this.$router.push('/');
              document.location.href = 'https://auth.skyservice.online/';
            } else {
              errList(resp.data.error[0]);
            }
          })
        } else {
          window.say.messageError(this.lang['Password']);
        }
      } catch(err) {
        window.say.messageError(this.lang['Error']);
      }
    }
  },
  computed: {
    passState() {
      return this.accountPassword.length >= 1 ? true : false;
    },
    // Мова додатку
    lang() {
      return window.lang;
    },
    capState() {
      return this.captcha.length == 4 ? true : false;
    }
  }
}
</script>

<style scoped>
.form-control.is-valid, .form-control.is-valid:focus {
  border-color: #00c279;
}

.form-control.is-valid {
  border-color: #00c279;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2300C279' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

.form-control.is-invalid, .form-control.is-invalid:focus {
  border-color: #ff3548;
}

.form-control.is-invalid {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ff3548' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
}

  .buttons-flex-end {
    display: flex;
    justify-content: flex-end;
  }

  .longWord {
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  #captcha-del {
    height: 2rem;
    width: 2rem;
  }

  .btn-secondary,
  .btn-success {
    width: 49%;
  }

  .buttons {
    display: flex;
    justify-content: space-between;
  }

  .btn-success {
  background-color: #00c279;
  border: none;
  text-transform: uppercase;
  font-size: 10pt;
}

.btn-success:not(:disabled):not(.disabled):active {
  background-color: #00B26F;
}

.btn-success:hover {
  background-color: #00B26F;
}

.btn-secondary {
  color: gray;
  background-color: white;
  border: none;
  text-transform: uppercase;
  font-size: 10pt;
}

.btn-secondary:not(:disabled):not(.disabled):active {
  background-color: white;
  color: gray;
}

.btn-secondary:hover {
  text-decoration: underline;
  color: gray;
  background-color: white;
}

  .center-text {
    text-align: center;
  }

  .grey-span {
    color: grey;
  }

  .imgDiv {
    text-align: center;
    height: 100px;
  }

  .capImg {
    height: 100px;
  }
</style>